import { useTranslation } from 'react-i18next';

const steps = [
  { key: 'how_step1', desc: 'how_step1_desc', icon: 'ri-search-line' },
  { key: 'how_step2', desc: 'how_step2_desc', icon: 'ri-bar-chart-grouped-line' },
  { key: 'how_step3', desc: 'how_step3_desc', icon: 'ri-user-search-line' },
  { key: 'how_step4', desc: 'how_step4_desc', icon: 'ri-image-line' },
  { key: 'how_step5', desc: 'how_step5_desc', icon: 'ri-truck-line' },
  { key: 'how_step6', desc: 'how_step6_desc', icon: 'ri-shield-check-line' },
];

export default function HowItWorks() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-4">
            {t('how_title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {steps.map((step, index) => (
            <div
              key={step.key}
              className="group relative p-6 md:p-8 rounded-2xl bg-white border border-background-200 hover:border-primary-200 hover:shadow-lg transition-all duration-300 animate-slide-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300 mb-5">
                <i className={`${step.icon} text-xl md:text-2xl`} />
              </div>
              <div className="text-sm font-semibold text-primary-500 mb-1 uppercase tracking-wider">
                Step {index + 1}
              </div>
              <h3 className="text-lg md:text-xl font-bold text-foreground-900 mb-2">
                {t(step.key)}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {t(step.desc)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}